import { css } from 'styled-components'

/**
 * nuka-carousel scrolls with positive physical `scrollLeft` offsets and maps swipes and arrow keys to physical
 * directions, so an RTL scroller clamps it to the first slide. Keep its scroller left-to-right in RTL, which keeps
 * paging, swipes and keys consistent with each other, and restore the document direction inside each slide.
 */
export default css`
  [dir="rtl"] .nuka-overflow {
    direction: ltr;
  }

  [dir="rtl"] .nuka-wrapper > * {
    direction: rtl;
  }
`
